import _debounce from 'lodash/debounce';
export class NumberFieldService {
    // store debounced functions per-field so hooks aren't used in services
    static debounceFns: { [key: string]: any } = {};
    static handleNumberField = async (e, data, idx, idy, prevState, updateLocalState, keyUp, configType, subConfigType) => {
        let { name, value } = e.target ? e.target : e;
        const { DynamicQuestions, isEdit, ClientCode, error, client_form } = prevState;

        const key = name || (data && data.question) || 'global_textfield';
        if (!NumberFieldService.debounceFns[key]) {
            NumberFieldService.debounceFns[key] = _debounce((eventValue, prevState, dataParam, configTypeParam, subConfigTypeParam, updateLocalStateParam, keyUpParam) => {
                try {
                    keyUpParam && keyUpParam(eventValue, prevState, dataParam, configTypeParam, subConfigTypeParam, updateLocalStateParam);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error('NumberFieldService debounced keyUp error', err);
                }
            }, 1000);
        }
        const debounceFn = NumberFieldService.debounceFns[key];

        let updatedDynamicQuestions = [...DynamicQuestions];
        let updatedError = { ...error };
        updatedDynamicQuestions = updatedDynamicQuestions.map((question) => {
            return {
                ...question,
                questions: question.questions.map((ques) => {
                    if (ques.question === name) {
                        return {
                            ...ques,
                            answer: value
                        };
                    }
                    return ques;
                })
            };
        });

        let updatedClientForm = { ...client_form };

        if (isEdit && name === 'Client_Code') {
            updatedClientForm = {
                ...updatedClientForm,
                [name]: value,
                Client_Code1: ClientCode
            };
        } else {
            updatedClientForm[name] = value;
        }

        let ErrorData = NumberFieldService.ValidateField(name, value, data, updatedError);

        await updateLocalState({
            ...ErrorData,
            DynamicQuestions: updatedDynamicQuestions,
            client_form: updatedClientForm
        });
        if (data?.is_primary_key) {
            const eventValue = { name: name, value: value }
            debounceFn(eventValue, prevState, data, configType, subConfigType, updateLocalState, keyUp);
        }
    };
    
    static ValidateField(name, value, data, updatedError) {
        const error_msg = data.error_msg || '';

        const val1 = parseFloat(data.validation1);
        const val2 = parseFloat(data.validation2);
        const numericValue = parseFloat(value);

        const minValue = Number.isNaN(val1) ? 0 : val1;
        const maxValue = Number.isNaN(val2)
            ? Number.MAX_SAFE_INTEGER
            : val2;

        const invalidNumber = Number.isNaN(numericValue);

        const err =
            invalidNumber || numericValue < minValue;

        const err1 =
            invalidNumber || numericValue > maxValue;
       
        updatedError[name] =
            ((err || err1) && error_msg) ? error_msg : [];

        return {
            error: updatedError,
            hasError:
                data.related === 'no'
                    ? false
                    : err || err1
        };
    }

}

export default NumberFieldService;
